import { Component, type ErrorInfo, type ReactNode } from 'react';
import { captureException } from './analytics';

// Root error boundary. Without it, a render error anywhere unmounts the whole
// tree and leaves a blank page. Shows a Reload screen instead, and reports the
// crash to PostHog when analytics is on (a no-op otherwise). Not posthog-js's
// PostHogErrorBoundary: that needs a PostHogProvider, and this must work with
// analytics off.

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    captureException(error, 'render', info);
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <div role="alert" style={{ padding: '48px 24px', textAlign: 'center' }}>
        <p style={{ marginBottom: 16 }}>Something went wrong. Please reload the page.</p>
        <button type="button" className="btn highlighted-btn" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
